var map = {
	"./ar/photo/index.vue": [
		258,
		8568,
		258
	],
	"./bn/photo/index.vue": [
		3172,
		8568,
		3172
	],
	"./en/photo/index.vue": [
		1843,
		8568,
		1843
	],
	"./fa/photo/index.vue": [
		5641,
		8568,
		5641
	],
	"./ur/photo/index.vue": [
		8204,
		8568,
		8204
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8049;
module.exports = webpackAsyncContext;